import React from 'react';

import type { MogulNFTToken } from '../../hooks/nft-contract.hooks';
import { NFTViewCard } from './card/NFTViewCard.component';
import styles from './NFTBalances.module.css';

export interface Props {
  nfts: MogulNFTToken[];
  nftIds: number[];
  nftBalances: {
    [key: string]: number;
  };
  contractAddress: string;
}

export const NFTBalancesComponent: React.FC<Props> = props => {
  const { nfts, nftIds, nftBalances } = props;
  const nftsOwned = Object.keys(nftBalances).reduce(
    (acc, next) => acc + nftBalances[next],
    0,
  );
  return (
    <div className={styles.nftBalancesContainer}>
      <div className={styles.headerContainer}>
        <h1 className={styles.nftHeader}>your digital collectibles</h1>
      </div>
      {typeof nftsOwned !== 'undefined' && nftsOwned === 0 && (
        <span className={styles.nftEmptyMessage}>
          You have no Digital Collectibles
        </span>
      )}
      <>
        {nftIds
          .filter(id => nftBalances[id] > 0)
          .map(nftId => (
            <div className={styles.nftCardContainer} key={nftId}>
              <NFTViewCard
                contractAddress={props.contractAddress}
                nft={nfts[nftId]}
                nftBalance={nftBalances[nftId]}
              />
            </div>
          ))}
      </>
    </div>
  );
};
